export const SerializerDecimal = (value?: any) => {
    return value?.toString().replace(',', '.');
};

export const DesserializerDecimal = (value?: any) => {
    return value?.toString().replace('.', ',');
};
